import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { FACTURA, ORDEN_SERVICIO, OTROS } from '../../../common/types/tipoComprobanteType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import requerimientoService from '../../../service/logistica/requerimientoService';
import ImportarRequerimientoModal from './ImportarRequerimientoModal';
import { APROBADO } from '../../../common/types/ordenCompraEstadoType';
import { LOGISTICA_REQUERIMIENTO } from '../../../common/types/referenciaOrigenType';


import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import vendedorService from '../../../service/administracion/vendedorService';
import proveedorService from '../../../service/administracion/proveedorService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import proyectoService from '../../../service/administracion/proyectoService';
import ordenServicioService from '../../../service/logistica/ordenServicioService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import empleadoService from '../../../service/administracion/empleadoService';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';

import Header from '../../../components/Header';
import ResultList from './ResultList';
import Filters from './Filters';
import FormModal from './FormModal';
import FormModalVer from '../OrdenServicio/FormModalVer';
import BuscarServicioModal from './BuscarServicioModal';

import RenombrarServicioModal from './RenombrarServicioModal';
import ImprimirModal from './ImprimirModal';
import IngresoObservacionModal from '../OrdenServicioAprobacion/IngresoObservacionModal'
import { LOGISTICA } from '../../../common/types/moduloType';
import { APROBAR_OS, VER_SERIES_LOG } from '../../../common/types/configuracionType';
import { lst_tipo_afectacion } from '../../../common/types/tipoAfectacion';
import DetalleIngreso from './DetalleIngreso';

var formModalPorImportar = null;
var referenciaCount = 1;
var products = [];

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.state = {
            loadingSource: true,
            loadingPrint: true,
            importarRequerimientoVisible: false,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            // almacenes: [],
            vendedores: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            detracciones: [],
            proyectos: [],
            proveedores: [],
            configuraciones: [],
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                documento: '',
                serie: '',
                idEstadoOrdenServicio: 0,
                idProveedor: 0,
                idProyecto: 0,
                tipoReporte: 1,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            productoVisible: false,
            visibleVer: false,
            renombrarProductoVisible: false,
            observacionVisible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            importarRequerimientoModal: {
                nombre: '',
                dataSource: [],
                dataSourceDetalle: [],
                selectedRowKeys: []
            },

            renombrarProductoModal: {
                nombre: '',
                idProducto: 0
            },
            imprimirFormValues: {
                file: undefined,
                idOrdenCompra: 0
            }
        }
    }

    fetchMinCurrentDateStr(firstDayOfTheMonth) {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var dd = firstDayOfTheMonth === true ? '01' : String(date.getDate()).padStart(2, '0');
        return yyyy + '/' + mm + '/' + dd;
    };

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idMoneda: SOLES,
            idProveedor: 0,
            idProyecto: 0,
            idEstablecimientoProveedor: 0,
            // idAlmacen: 0,
            idListaPrecio: 0,
            idEstablecimiento: 0,
            serie: "OS01",
            documento: "",
            fechaStr: global.fetchCurrentDateStr(),
            fechaVencimientoStr: global.fetchCurrentDateStr(),
            minFechaStr: this.fetchMinCurrentDateStr(),
            diasVencimiento: 0,
            tipoCambio: 0,
            observacion: "",
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            idTipo: 1,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            idEmpleado: 0,
            empleado: [],
            // almacenLoading: false,
            proveedorLoading: false,
            condicion: '',
            plazo: '',
            activeKey: "1",
            documentoProveedor: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            // almacenes: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            proveedores: [],
        }
    };

    fetchEmptyFormValuesDos = () => {
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: 0,
            idProveedor: 0,
            idEstablecimientoProveedor: 0,
            idMoneda: SOLES,
            idListaPrecio: 0,
            idEstablecimiento: 0,
            idProyecto: 0,
            serie: 'OC01',
            documento: "",
            empleado: [],
            diasVencimiento: 0,
            tipoCambio: 0,
            observacion: "",
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            idEmpleado: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,

            proveedorLoading: false,
            activeKey: "1",
            documentoProveedor: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            proveedores: [],

        }
    };

    fetchEditFormValues = (value) => {
        return {
            id: value.ordenServicio.id,
            idProveedor: value.ordenServicio.idProveedor,
            idEstablecimientoProveedor: value.ordenServicio.idEstablecimientoProveedor,
            idMoneda: value.ordenServicio.idMoneda,
            idListaPrecio: 0,
            idEstablecimiento: value.ordenServicio.idEstablecimiento,
            idProyecto: value.ordenServicio.idProyecto,
            serie: value.ordenServicio.serie,
            documento: value.ordenServicio.documento,
            documentoProveedor: value.ordenServicio.documentoProveedor,
            fechaStr: value.ordenServicio.fechaStr,
            fechaVencimientoStr: value.ordenServicio.fechaVencimientoStr,
            diasVencimiento: value.ordenServicio.diasVencimiento,
            tipoCambio: value.ordenServicio.tipoCambio,
            observacion: value.ordenServicio.observacion,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            condicion: value.ordenServicio.condicion,
            plazo: value.ordenServicio.plazo,
            idEmpleado: value.ordenServicio.idEmpleado,
            sumaSubTotal: value.ordenServicio.subTotal,
            sumaIgv: value.ordenServicio.igv,
            sumaTotal: value.ordenServicio.total,

            proveedorLoading: false,
            activeKey: "1",
            monedas: [],
            empleado: [],

            listasPrecio: [],
            establecimientos: [],

            proveedores: [],
            direcciones: [],
            tiposComprobante: [],

            proyectos: [],
            proveedores: [],

            nombreMoneda: value.ordenServicio.nombreMoneda,
            nombreProyecto: value.ordenServicio.nombreProyecto,
            // nombreAlmacen: value.ordenServicio.nombreAlmacen,
            proveedor: value.ordenServicio.proveedor,
            direccionEstablecimiento: value.ordenServicio.direccionEstablecimiento,
            nombreEstablecimientoSucursal: value.ordenServicio.nombreEstablecimientoSucursal
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            documento: '',
            serie: this.state.filter.serie,
            idEstadoOrdenServicio: 0,
            idProveedor: 0,
            idProyecto: 0,
            tipoReporte: 1,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
        if (property = 'tipoReporte') {
            this._handlePagination(filter)
        }
    };

    handleNew = async () => {

        var idSoles = SOLES;
        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === idSoles);
        formValues.establecimientos = this.state.establecimientos;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.proyectos = this.state.proyectos;
        formValues.proveedores = this.state.proveedores;
        formValues.empleado = this.state.empleado;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: ORDEN_SERVICIO.ID
        }
        const datosIniciales = await ordenServicioService.datosIniciales(datosInicialesFilter);

        if (datosIniciales !== undefined) {
            formValues.idAlmacen = datosIniciales.idAlmacen;
            formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
            formValues.serie = datosIniciales.serie;

        }

        var productos = await productoService.listar();
        var productos_filter = productos.filter(m => m.idTipoProducto === 2);

        if (formValues.serie == "" || formValues.serie == null) {
            setTimeout(() => {
                dialog.error("Tiene que registrar serie correlativo para poder registrar el documento");

            }, 100);

        } else {

            this.setState({
                visible: true,
                formValues,
                productos: productos_filter ? productos_filter : [],
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: []
                },
                importarRequerimientoModal: {
                    ...this.state.importarRequerimientoModal,
                    selectedRowKeys: []
                }
            });
        }

    }

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    }

    handleChangeForm = async (property, value, form) => {

        if (property === "idProveedor") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : []
                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoProveedor: { key: direcciones.length > 0 ? direcciones[0].id : undefined }
                });
            });
        }

        if (property === "fechaStr") {
            debugger
            console.log('cambio 1')
            var arrayD1 = value.split('/');

            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),

                    fechaStr: value,

                }
            });
        }

        if (property === "fechaVencimientoStr") {
            const dias_vencimiento = this.CalcularDiasVencimiento(this.state.formValues.fechaStr, value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    diasVencimiento: dias_vencimiento,
                    fechaVencimientoStr: value
                }
            });
        }

        if (property === "diasVencimiento") {
            var arrayD1 = this.state.formValues.fechaStr.split('/');
            var date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
            var fechaVencimiento = date1.setDate(date1.getDate() + parseInt(value));

            let day = date1.getDate()
            let month = date1.getMonth() + 1
            let year = date1.getFullYear()

            var fechaVencStr = '';

            if (month < 10) {
                fechaVencStr = `${day}/0${month}/${year}`;
            } else {
                fechaVencStr = `${day}/${month}/${year}`;
            }

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    fechaVencimientoStr: fechaVencStr
                }
            });
        }

        if (property === "idMoneda") {
            // const listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === value);
            // this.setState({
            //     formValues: {
            //         ...this.state.formValues,
            //         listasPrecio: listasPrecio ? listasPrecio : []
            //     }
            // });
        }

        // if (property === "idListaPrecio") {
        //     const listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === value);
        //     this.setState({
        //         formValues: {
        //             ...this.state.formValues,
        //             listasPrecio: listasPrecio ? listasPrecio : []
        //         }
        //     });
        // }
    };

    CalcularDiasVencimiento = (fecha_1, fecha_2) => {
        var arrayD1 = fecha_1.split('/');
        var arrayD2 = fecha_2.split('/');

        var date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
        var dateFV = new Date(arrayD2[2] + "/" + arrayD2[1] + "/" + arrayD2[0]);

        var Difference_In_Time = dateFV.getTime() - date1.getTime();
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

        return Difference_In_Days;
    }

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = () => {
        if (this.state.formValues.activeKey === "1")
            this.handleBuscarProducto();

        if (this.state.formValues.activeKey === "2")
            this.handleAddReferencia();
    };

    handleBuscarProducto = () => {

        this.setState({
            productoVisible: true,
            productoModal: {
                ...this.state.productoModal,
                dataSource: this.state.productos
            }
        });
    }

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: false
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (id) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== id.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            },
        });
    };

    handleChangeProductoModal = (value) => {
        if (value != null && value != undefined && value != '') {
            const dataSource = this.state.productos.filter(item => {
                return (item.codigoReferencia + ' - ' + item.nombre)
                    .toUpperCase()
                    .match(value.toUpperCase());
            });

            this.setState({
                productoModal: {
                    ...this.state.productoModal,
                    dataSource: dataSource
                }
            });
        } else {
            this.setState({
                productoModal: {
                    ...this.state.productoModal,
                    dataSource: this.state.productos
                }
            });
        }
    };

    handleChangeSelectedRowKey = (selected, rows) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        rows.forEach(item => {
            var filter = this.state.formValues.listaComprobanteDetalle.filter(m => { return m.idProducto === item.id; });
            if (filter.length === 0) {

                listaComprobanteDetalle.push({
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.id,
                    nombre: item.nombre,
                    cantidad: 0,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: 0,
                    total: 0,
                    flagAfecto: item.flagIGVAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: 0,
                    igv: 0,
                    idImpuesto: item.idImpuesto,
                    precioNuevo: 0,
                })
            }
        });

        listaComprobanteDetalle = listaComprobanteDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selected
            }
        });
    };

    handleRemoverProducto = (identifier) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== identifier);
        var selectedRowKeys = this.state.productoModal.selectedRowKeys.filter(m => m !== identifier);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selectedRowKeys
            }
        });
    };

    handleOnChangeProveedor = async (value) => {
        console.log(value);
        debugger
        var numDoc = value.label.split('-')[value.label.split('-').length - 1];
        console.log(value.label);

        this.setState({
            formValues: {
                ...this.state.formValues,
                documentoProveedor: numDoc
            }
        });

        const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(value.key);
        if (direccionesEstablecimientos === undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,

                    direcciones: [],
                }
            });
        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,

                    direcciones: direccionesEstablecimientos,
                    documentoProveedor: numDoc
                }
            });
        }
    }

    handleBuscarProveedor = async (value, form) => {
        this.setState({
            formValues: { ...this.state.formValues, proveedorLoading: true },
        });

        //const response = await padronReducidoService.logistica_proveedor(value);
        var numberDocument = form.getFieldValue("documentoProveedor");
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }

        var response = numberDocument.length == 8 ? await padronReducidoService.obtenerProveedorDniApi(value) :
            await padronReducidoService.obtenerProveedorRucApi(value);
        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            this.setState({ formValues: { ...this.state.formValues, proveedorLoading: false } });

            return;
        }

        if (response.status === 200) {
            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        proveedorLoading: false,
                        direcciones: response.data.direcciones,
                    },
                },
                () => {
                    form.setFieldsValue({
                        proveedores: response.data.proveedores,
                        idProveedor:
                            response.data.proveedores.length > 0
                                ? { key: response.data.proveedores[0].id }
                                : undefined,
                        idEstablecimientoProveedor:
                            response.data.direcciones.length > 0
                                ? { key: response.data.direcciones[0].id }
                                : undefined,
                        direccionProveedor:
                            response.data.direcciones.length > 0
                                ? response.data.direcciones[0].direccion
                                : ""
                    });
                }
            );
        } else {
            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        clienteLoading: false,
                        direcciones: [],
                    },
                },
                () => {
                    form.setFieldsValue({
                        clientes: [],
                        idCliente: undefined,
                        idEstablecimientoCliente: undefined,
                    });
                }
            );
        }
    };

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.setState({
            renombrarProductoVisible: true,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: row.nombre,
                idProducto: row.idProducto
            }
        })
    }

    handleOkChangeNameProduct = (value, form) => {
        var listaComprobanteDetalle_aux = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto !== value.idProducto);

        var currentRow = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === value.idProducto)[0];
        currentRow.nombre = value.nombre;
        //console.log(currentRow)
        listaComprobanteDetalle_aux.push(currentRow);

        var empty_renombrarProductoModal = {
            nombre: '',
            idProducto: 0
        };

        form.setFieldsValue(empty_renombrarProductoModal);
        form.resetFields();

        this.setState({
            renombrarProductoVisible: false,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: '',
                idProducto: 0
            },
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle_aux
            }
        });
    }

    handleSave = async (values, form) => {

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            if (values.ordenServicioDetalles !== undefined) {
                for (var i = 0; i < values.ordenServicioDetalles.length; i++) {
                    var item = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === values.ordenServicioDetalles[i].idProducto)[0];
                    values.ordenServicioDetalles[i].nombre = item.nombre;
                }
            }

            var response;
            if (values.id === 0 || values.id === undefined)
                response = await ordenServicioService.registrar(values);
            else
                response = await ordenServicioService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValuesDos();
                this.setState({ visible: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleEdit = async (values) => {
        const response = await ordenServicioService.obtenerPorId(values.id);
        if (response !== undefined) {
            debugger
            var formValues = this.fetchEditFormValues(response);
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
            formValues.establecimientos = this.state.establecimientos;
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;
            formValues.empleado = this.state.empleado;
            formValues.tipoAfectacion = lst_tipo_afectacion;


            const filterSearchProveedor = {
                numeroDocumento: formValues.documentoProveedor,
                idTipoComprobante: OTROS.ID
            }
            const responseProveedores = await proveedorService.obtenerTodos(filterSearchProveedor);
            const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(response.ordenServicio.idEntidadProveedor);

            formValues.proveedores = responseProveedores;
            formValues.direcciones = direccionesEstablecimientos;



            const products = [];
            for (var i = 0; i < response.ordenServicioDetalles.length; i++) {
                var item = response.ordenServicioDetalles[i];
                var oneProd = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    precioUnitarioSinIGV: item.precioUnitarioSinIGV,
                    idImpuesto: item.idImpuesto,
                    precioNuevo: parseFloat(item.total),
                }

                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }

            for (var i = 0; i < response.ordenServicioReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.ordenServicioReferencias[i];
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    idReferencia: item.idReferencia,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            referenciaCount = response.ordenServicioReferencias.length + 1;

            var productos = await productoService.listar();
            var productos_filter = productos.filter(m => m.idTipoProducto === 2);

            this.setState({
                visible: true,
                formValues,
                productos: productos_filter ? productos_filter : [],
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: products
                },
                requerimientos: [],
                importarRequerimientoModal: {
                    ...this.state.importarRequerimientoModal,
                    selectedRowKeys: []
                }

            });

        }
    }

    handleVer = async (values) => {
        const response = await ordenServicioService.obtenerPorId(values.id);
        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);

            for (var i = 0; i < response.ordenServicioDetalles.length; i++) {
                var item = response.ordenServicioDetalles[i];
                var oneProd = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    // precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv
                }

                formValues.listaComprobanteDetalle.push(oneProd);

            }

            for (var i = 0; i < response.ordenServicioReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.ordenServicioReferencias[i];
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    nombreTipoComprobante: item.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            this.setState({
                visibleVer: true,
                formValues
            });
        }
    }

    handleAnular = async (values) => {
        var flagAnular = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_OS).length >= 1 ? true : false;

        if (!flagAnular) {
            message.warning('Usted no puede anular Orden de Servicio.');
            return false;
        }
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var data = {
                idOrdenServicio: values.id,
                codOrdenServicioEstado: 'AN',
                observacionRechazado: ''
            };
            var response = await ordenServicioService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });

                message.success('Registrado anulado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    handleSelectedRowRequerimientoPorImportar = async (selected, rows) => {

        var arraySelect = [];
        const idReqImport = selected[selected.length - 1];
        const response = await requerimientoService.obtenerPorId(idReqImport);

        arraySelect.push(idReqImport);

        if (response !== undefined) {

            var formValues = this.fetchEmptyFormValues(response);
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
            formValues.establecimientos = this.state.establecimientos;
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;
            formValues.idRequerimiento = idReqImport;
            formValues.idProyecto = response.requerimiento.idProyecto;

            if (this.state.formValues.id !== undefined && this.state.formValues.id > 0) {
                formValues.id = this.state.formValues.id;
                formValues.serie = this.state.formValues.serie;
                formValues.documento = this.state.formValues.documento;
            }

            products = [];
            for (var i = 0; i < response.requerimientoDetalles.length; i++) {
                var item = response.requerimientoDetalles[i];
                var oneProd = {
                    identifier: global.fetchUniqueCode(),
                    id: item.id,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: 0,
                    total: 0,
                    flagAfecto: item.flagIGVAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: 0,
                    igv: 0,
                    precioNuevo: 0,
                    idImpuesto: item.idImpuesto,
                }
                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }

            var itemRefReq = {
                identifier: global.fetchUniqueCode(),
                idReferencia: response.requerimiento.id,
                idReferenciaOrigen: LOGISTICA_REQUERIMIENTO,
                idTipoComprobante: 88,
                serie: response.requerimiento.serie,
                documento: response.requerimiento.documento,
                flagInterno: true
            }
            formValues.listaComprobanteReferencia.push(itemRefReq);
            // referenciaCount = 2;


            formModalPorImportar = formValues;

            this.setState({
                importarRequerimientoVisible: true,
                importarRequerimientoModal: {
                    ...this.state.importarRequerimientoModal,
                    dataSourceDetalle: formValues.listaComprobanteDetalle,
                    selectedRowKeys: arraySelect//selected
                }
            })
        }
    }
    handleImportarRequerimiento = async () => {
        var filterSearchReq = {
            idEstadoRequerimiento: APROBADO,
            filtro: '',
            idTipoOperacion: 2
        };
        debugger
        var requerimientos = await requerimientoService.listarPorEstado(filterSearchReq);
        this.setState({
            importarRequerimientoVisible: true,
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal,
                dataSource: requerimientos ? requerimientos : [],
                dataSourceDetalle: []
            }
        })
    }

    handleOkImportarRequerimiento = (values, form) => {
        if (formModalPorImportar === undefined || formModalPorImportar === null) {
            message.warning('Debe seleccionar un requerimiento.');
            return;
        }

        var idSoles = SOLES;
        formModalPorImportar.monedas = this.state.monedas;
        formModalPorImportar.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formModalPorImportar.listasPrecio = this.state.listasPrecio.filter(m => m.id === idSoles);
        formModalPorImportar.establecimientos = this.state.establecimientos;
        formModalPorImportar.idListaPrecio = formModalPorImportar.listasPrecio.length === 0 ? 0 : formModalPorImportar.listasPrecio[0].id;
        formModalPorImportar.tiposComprobante = this.state.tiposComprobante;
        formModalPorImportar.proyectos = this.state.proyectos;
        formModalPorImportar.activeKey = "2";

        this.setState({
            importarRequerimientoVisible: false,
            formValues: {
                ...this.state.formValues,
                idProyecto: formModalPorImportar.idProyecto,
                listaComprobanteDetalle: formModalPorImportar.listaComprobanteDetalle,
                listaComprobanteReferencia: formModalPorImportar.listaComprobanteReferencia,
                sumaSubTotal: 0,
                sumaIgv: 0,
                sumaTotal: 0,
                idRequerimiento: formModalPorImportar.idRequerimiento,
                activeKey: "2",
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: products
            }
        })

    }
    handleChangeRequerimientoModal = (value) => {
        const dataSource = this.state.requerimientos.filter(item => {
            return (item.serie + ' - ' + item.documento)
                .toUpperCase()
                .match(value.toUpperCase());
        });

        this.setState({
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal,
                dataSource: dataSource
            }
        });
    };
    handleExportExcel = async () => {
        this.setState({ loadingPdf: true });
        var response = await ordenServicioService.excel(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Orden de Servicio.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await ordenServicioService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Orden de Servicio.pdf");
    }


    handleDetalleExportExcel = async () => {
        this.setState({ loadingExcel: true });

        var response = await ordenServicioService.excelDetallado(this.state.filter);
        this.setState({ loadingExcel: false });

        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Orden de Servicio Detallado.xlsx");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await ordenServicioService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleImprimir = async (item) => {
        this.setState({ loadingPrint: true });

        var file = undefined;
        var response = await ordenServicioService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);
        this.setState({ loadingPrint: false });

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idOrdenServicio: item.id
            }
        });
    };

    //#REGION M


    handleRechazar = async (values) => {

        var flagAnular = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_OS).length >= 1 ? true : false;

        if (!flagAnular) {
            message.warning('Usted no puede rechazar Orden de Servicio.');
            return false;
        }
        dialog.confirm(`¿Desea rechazar la Orden de Servicio ${values.serie}-${values.documento}?`, async () => {

            const emptyForm = this.fetchEmptyFormValues();
            emptyForm.iD = values.id;
            this.setState({
                observacionVisible: true,
                formValues: emptyForm,
                ingresoObservacionModal: {
                    ...this.state.ingresoObservacionModal
                }
            });
        });
    }

    handleCompletarRechazo = async (values, form) => {

        var data = {
            idOrdenServicio: values.id,
            codOrdenServicioEstado: 'RE',
            observacionRechazado: values.observacionRechazo
        };

        var response = await ordenServicioService.actualizarEstado(data);

        if (response.status === 200) {
            var empty = this.fetchEmptyFormValues();
            this.setState({ observacionVisible: false, formValues: empty });
            form.setFieldsValue(empty);
            form.resetFields();

            message.success('Registrado rechazado correctamente.');

            this._handlePagination(this.state.filter);
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
            return;
        }

        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');

    }

    handleAprobar = async (values) => {
        var flagAprobar = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_OS).length >= 1 ? true : false;

        if (!flagAprobar) {
            message.warning('Usted no puede aprobar Orden de Servicio.');
            return false;
        }
        dialog.confirm(`¿Desea aprobar la Orden de Servicio ${values.serie}-${values.documento}?`, async () => {
            debugger
            var data = {
                idOrdenServicio: values.id,
                codOrdenServicioEstado: 'AP'
            };
            var response = await ordenServicioService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ observacionVisible: false, formValues: empty });

                message.success('Registrado aprobado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            };

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            };

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    //#ENDREGION

    async componentDidMount() {

        var idUsuario = auth.user().id;

        const datosIniciales = await ordenServicioService.datosIniciales({ idUsuario: idUsuario, idTipoComprobante: ORDEN_SERVICIO.ID, });
        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: LOGISTICA });
        var flagSerie = configuraciones.filter((m) => m.abreviatura === VER_SERIES_LOG).length >= 1 ? true : false;


        const serie = [undefined, null].includes(datosIniciales?.serie) ? flagSerie ? '' : '-' : datosIniciales.serie;
        this.setState({ filter: { ...this.state.filter, serie } });

        this._initPagination({ ...this.state.filter, serie }, ordenServicioService.paginacion);


        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const proyectos = await proyectoService.listar();
        const empleado = await empleadoService.listar();

        const filter = {
            numeroDocumento: null,
            idTipoComprobante: OTROS.ID
        }

        const proveedores = await proveedorService.obtenerTodos(filter);

        this.setState({
            loadingSource: false,
            loadingPrint: false,
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            monedas: monedas ? monedas : [],
            listasPrecio: listasPrecio ? listasPrecio : [],
            establecimientos: establecimientos ? establecimientos : [],
            vendedores: vendedores ? vendedores : [],
            tiposComprobante: tiposComprobante ? tiposComprobante : [],
            proyectos: proyectos ? proyectos : [],
            proveedores: proveedores ? proveedores : [],
            empleado: empleado ? empleado : [],
            configuraciones: configuraciones ? configuraciones : [],

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Orden de Servicio"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    entidades={this.state.proveedores}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    proyectos={this.state.proyectos}
                    configuraciones={this.state.configuraciones}

                />

                {this.state.filter.tipoReporte == 1 ?
                    <ResultList
                        pagination={this.state.pagination}
                        loadingEdit={this.state.loadingSource}
                        loadingPrint={this.state.loadingPrint}
                        onExportExcel={this.handleExportExcel}
                        onExportPdf={this.handleExportPdf}
                        onPrint={this.handlePrint}
                        onVer={this.handleVer}
                        onEditar={this.handleEdit}
                        onAnular={this.handleAnular}
                        onRechazar={this.handleRechazar}
                        onAprobar={this.handleAprobar}
                        onImprimir={this.handleImprimir}
                        onChange={this._handleChangePagination}
                    />
                    :
                    <DetalleIngreso
                        pagination={this.state.pagination}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        onExportExcel={this.handleDetalleExportExcel}
                        onChange={this._handleChangePagination}
                    />
                }
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarProveedor={this.handleBuscarProveedor}
                    onChangeProveedor={this.handleOnChangeProveedor}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onImportarRequerimiento={this.handleImportarRequerimiento}

                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onBlur={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeNameProduct={this.handleChangeNameProduct}
                />
                <BuscarServicioModal
                    visible={this.state.productoVisible}
                    formValues={this.state.productoModal}
                    onChange={this.handleChangeProductoModal}
                    onChangeRow={this.handleChangeSelectedRowKey}
                    onCancel={() => this.setState({ productoVisible: false })}
                />

                <ImportarRequerimientoModal
                    visible={this.state.importarRequerimientoVisible}
                    formValues={this.state.importarRequerimientoModal}
                    onChangeRequerimientoModal={this.handleChangeRequerimientoModal}
                    onChangeRow={this.handleSelectedRowRequerimientoPorImportar}
                    onCancel={() => this.setState({ importarRequerimientoVisible: false })}
                    onHandleOkImportarRequerimiento={this.handleOkImportarRequerimiento}
                />

                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <RenombrarServicioModal
                    visible={this.state.renombrarProductoVisible}
                    formValues={this.state.renombrarProductoModal}
                    onCancel={() => this.setState({ renombrarProductoVisible: false })}
                    onSaveRename={this.handleOkChangeNameProduct}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />

                <IngresoObservacionModal
                    visible={this.state.observacionVisible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ observacionVisible: false })}
                    onSave={this.handleCompletarRechazo}
                />
            </div>
        )
    }
}